export type UpdateProjectStakeholdersResponse = {};
